// Referral discount auto-apply. Attaches a customer's referral code to their cart via the same
// cart-level discount API the cart drawer's own "Discount code" box uses (/cart/update.js), rather
// than the old checkout-redirect endpoint — no redirect involved, so it can't loop on an empty cart.
(function () {
  if (window.__referralDiscountLoaded) return;
  window.__referralDiscountLoaded = true;

  var passiveCode = window.FoxTheme && window.FoxTheme.referral && window.FoxTheme.referral.code;

  var params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch (e) {
    params = null;
  }
  var explicitCode = params && (params.get('discount') || params.get('coupon_code'));

  if (!passiveCode && !explicitCode) return;

  function getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js').then(function (res) {
      return res.json();
    });
  }

  function applyDiscounts(codes) {
    var config = FoxTheme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var formData = new FormData();
    formData.append('discount', codes.join(','));
    config.body = formData;
    return fetch(FoxTheme.routes.cart_update_url, config);
  }

  // Explicit link click: apply + go straight to checkout. Gated on a non-empty cart — a one-time
  // navigation, so even an empty-cart checkout redirect (Shopify sends it home) can't loop.
  if (explicitCode) {
    getCart().then(function (cart) {
      if (!cart || cart.item_count < 1) return;
      window.location.href = window.Shopify.routes.root + 'checkout?discount=' + encodeURIComponent(explicitCode);
    });
  }

  if (!passiveCode) return;

  // If the customer explicitly removes the code via the cart drawer's own "x", stop re-adding it
  // for the rest of this session — otherwise the remove button would look broken (removal fires a
  // cart-update, which is also our retry signal, so it'd silently come straight back).
  var REMOVED_KEY = 'referralDiscountRemoved';
  function wasRemovedByCustomer() {
    try {
      return sessionStorage.getItem(REMOVED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }
  document.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('[is="cart-discount-remove"]');
    if (!removeBtn) return;
    var item = removeBtn.closest('[data-discount-code]');
    if (item && item.dataset.discountCode === passiveCode) {
      try {
        sessionStorage.setItem(REMOVED_KEY, '1');
      } catch (e) {}
    }
  });

  // Passive: keep the account's referral code attached while browsing. Never navigates. Checks
  // cart.discount_codes first every time, so re-running this on a cart that already has it is a
  // cheap no-op — safe to call as often as the cart actually changes.
  function tryPassiveApply(cart) {
    if (wasRemovedByCustomer()) return;
    if (!cart || cart.item_count < 1) return;
    var existing = (cart.discount_codes || []).map(function (d) {
      return d.code;
    });
    if (existing.indexOf(passiveCode) !== -1) return;
    applyDiscounts(existing.concat([passiveCode]))
      .then(function () {
        // Silently re-render the cart drawer's own content so the discount shows up right away
        // instead of only after a checkout round-trip — open:false means it never pops open.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      })
      .catch(function () {});
  }

  // Covers arriving on a page with items already in cart (nothing mutates, so nothing else fires).
  getCart()
    .then(tryPassiveApply)
    .catch(function () {});

  // Covers starting empty and adding the first item mid-session: cart-update fires on every add/
  // remove/quantity/discount change theme-wide, each carrying the fresh cart — that's the retry.
  if (window.FoxTheme && window.FoxTheme.pubsub) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (data) {
      tryPassiveApply(data && data.cart);
    });
  }

  // Safety net: the Checkout button carries the code on its own navigation so it never races the
  // background apply above.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.querySelector('[name="checkout"]')) return;
      event.preventDefault();
      window.location.href = window.Shopify.routes.root + 'checkout?discount=' + encodeURIComponent(passiveCode);
    },
    true
  );
})();
